export default __webpack_public_path__ + "static/media/projectThumb6.26d86cc9.png";